import subjectSlice from "@pages/EducationalStructure/Subject/store/subjectSlice";
import academicDepartmentSlice from "@pages/EducationalStructure/AcademicDepartment/store/academicDepartmentSlice";
import professionsSlice from "@pages/EducationalStructure/Profession/store/professionsSlice";
import facultySlice from "@pages/EducationalStructure/Faculty/store/facultySlice";
import educationDegreeSlice from "@pages/EducationalStructure/EducationalDegree/store/educationDegreeSlice";
import learningFormatSlice from "@pages/EducationalStructure/LearningFormat/store/learningFormatSlice";

export const structureReducer = {
    educationalDegree: educationDegreeSlice.reducer,
    subjects: subjectSlice.reducer,
    academicDepartment: academicDepartmentSlice.reducer,
    professions: professionsSlice.reducer,
    faculty: facultySlice.reducer,
    learningFormat: learningFormatSlice.reducer,
}